<template>
  <div class="afterSaleDetail">
    <el-form
      ref="afterSaleDetailForm"
      label-position="left"
      :inline="true"
      :model="afterSaleDetailForm"
      class="demo-form-inline"
      style="margin-bottom:10px;"
    >
      <el-form-item label="日期">
        <el-col :span="11">
          <el-date-picker
            type="date"
            placeholder="开始日期"
            v-model="afterSaleDetailForm.start_time"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            style="width: 100%;"
          ></el-date-picker>
        </el-col>
        <el-col class="line" :span="2">-</el-col>
        <el-col :span="11">
          <el-date-picker
            type="date"
            placeholder="结束日期"
            v-model="afterSaleDetailForm.end_time"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            style="width: 100%;"
          ></el-date-picker>
        </el-col>
      </el-form-item>
      <el-form-item label="服务编号">
        <el-input
          v-model="afterSaleDetailForm.as_number"
          @keyup.enter.native="searchAftersaleList"
          placeholder="服务编号"
        ></el-input>
      </el-form-item>
      <el-form-item label="订单号">
        <el-input
          v-model="afterSaleDetailForm.order_number"
          @keyup.enter.native="searchAftersaleList"
          placeholder="订单号"
        ></el-input>
      </el-form-item>
      <el-form-item label="锐锢编码">
        <el-input
          v-model="afterSaleDetailForm.ruigu_code"
          @keyup.enter.native="searchAftersaleList"
          placeholder="锐锢编码"
        ></el-input>
      </el-form-item>
      <el-form-item label="售后类型">
        <el-select
          v-model="afterSaleDetailForm.as_type"
          clearable
          placeholder="售后类型"
        >
          <el-option
            v-for="item in typeList"
            :key="item.value"
            :value="item.value"
            :label="item.label"
          ></el-option>
        </el-select>
      </el-form-item>
      <!-- 工厂|直发 支持多选 -->
      <el-form-item label="售后状态" v-if="showAfterSaleSeach">
        <el-select
          v-model="afterSaleDetailForm.as_status"
          clearable
          placeholder="售后状态"
          :multiple="isZhifaOrFactory ? true : false"
          :collapse-tags="isZhifaOrFactory ? true : false"
          style="width:200px"
        >
          <el-option
            v-for="item in statusList"
            :key="item.value"
            :value="item.value"
            :label="item.label"
          ></el-option>
        </el-select>
      </el-form-item>
      <!-- 新逻辑 平台 直发 工厂 都可以显示 -->
      <el-form-item label="处理方式">
        <el-select
          v-model="afterSaleDetailForm.as_status_source"
          clearable
          placeholder="处理方式"
        >
          <el-option :value="2" label="客服处理"></el-option>
          <el-option :value="1" label="店铺处理"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="快递单号">
        <el-input
          v-model="afterSaleDetailForm.delivery_number"
          @keyup.enter.native="searchAftersaleList"
          placeholder="快递单号"
        ></el-input>
      </el-form-item>
      <el-form-item label="客户姓名/电话" label-width="90px">
        <el-input
          v-model="afterSaleDetailForm.user_name"
          @keyup.enter.native="searchAftersaleList"
          placeholder="客户姓名或电话"
        ></el-input>
      </el-form-item>
      <el-form-item label="物流联系电话" label-width="85px">
        <el-input
          v-model="afterSaleDetailForm.courier_mobile"
          @keyup.enter.native="searchAftersaleList"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="提货物流状态"
        label-width="90px"
        v-if="isZhifaOrFactory"
      >
        <el-select
          v-model="afterSaleDetailForm.in_box_status"
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="item in Object.keys(logStatusOptions)"
            :key="item"
            :label="logStatusOptions[item]"
            :value="item"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="送货物流状态"
        label-width="90px"
        v-if="isZhifaOrFactory"
      >
        <el-select
          v-model="afterSaleDetailForm.out_box_status"
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="item in Object.keys(logStatusOptions2)"
            :key="item"
            :label="logStatusOptions2[item]"
            :value="item"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="small" @click="searchAftersaleList"
          >查询</el-button
        >
        <!-- <el-button type="primary" size="small" @click="exportExcel">导出</el-button> -->
      </el-form-item>
    </el-form>
    <div class="boder-top">
      <div class="table-title">
        <h6>查询结果:</h6>
      </div>
      <div class="tableTitle">
        <div>
          <el-button
            size="small"
            type="primary"
            :disabled="receiveEnable"
            v-show="!showPrintType"
            @click="saleConfirm('receive')"
            >售后收货</el-button
          >
          <el-button
            size="small"
            type="primary"
            :disabled="confirmEnable"
            @click="saleConfirm('accept')"
            >售后确认</el-button
          >
          <el-button
            size="small"
            type="primary"
            :disabled="outEnable"
            @click="saleConfirm('return')"
            v-if="shopIds.indexOf(shop_id) < 0"
            >售后出库</el-button
          >

          <!-- <el-button size="small" type="primary" :disabled="closeEnable" @click="closeSale">关闭售后</el-button> -->
          <el-button
            size="small"
            type="primary"
            :disabled="labelEnable"
            v-show="showLabel"
            @click="printAftersale"
            >打印售后标签</el-button
          >
          <el-button
            size="small"
            type="primary"
            :disabled="sheetEnable"
            @click="printShippingList"
            >打印售后发货单</el-button
          >
          <el-button size="small" type="primary" @click="inputTs"
            >录入物流运单</el-button
          >
        </div>
      </div>
    </div>
    <after-sale-table
      ref="afterSaleTable"
      class="after-sale"
      @getSelectSaleData="getSelectSaleData"
      @getTrackNo="getTrackNo"
      v-loading="loadingAftersale"
      :data="aftersaleTableData"
      @getBoxData="getBoxData"
      @changeBoxData="changeBoxData"
      :statusActive="statusActive"
    ></after-sale-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 50, 100, 200]"
      :page-size="pagesize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalCount"
      v-if="showPagination"
    ></el-pagination>

    <el-tabs type="card" v-model="activeName">
      <el-tab-pane label="商品信息" name="goods_info">
        <after-sale-detail-table
          :data="aftersaleDetailTableData"
          :type="aftersaleDetailType"
        ></after-sale-detail-table>
      </el-tab-pane>
      <!-- 提货物流轨迹 -->
      <el-tab-pane
        label="提货物流轨迹"
        name="log_track_take"
        v-if="isZhifaOrFactory"
      >
        <orderTrack :type="1" :as_number="current_row_as_number" />
      </el-tab-pane>
      <!-- 送货物流轨迹 -->
      <el-tab-pane
        label="送货物流轨迹"
        name="log_track_delivery"
        v-if="isZhifaOrFactory"
      >
        <orderTrack :type="2" :as_number="current_row_as_number" />
      </el-tab-pane>
    </el-tabs>
    <!-- <div class="table-title">
      <h6>商品信息:</h6>
    </div>
    <after-sale-detail-table
      :data="aftersaleDetailTableData"
      :type="aftersaleDetailType"
    ></after-sale-detail-table> -->
    <after-sale-edit-dialog ref="afterSaleEditDialog"></after-sale-edit-dialog>
    <close-reason-dialog
      @refreshData="getAftersaleList"
      ref="closeReasonDialog"
    ></close-reason-dialog>
    <order-dialog ref="orderDialog" :boxData="boxData"></order-dialog>
    <el-dialog
      :visible.sync="boxDetailDialog"
      :append-to-body="true"
      width="500px"
    >
      <span slot="title" :style="{ color: '#fff' }"
        >服务编号：{{ rowData.as_number }}</span
      >
      <waybillDetial v-if="boxDetailDialog" :row="rowData"></waybillDetial>
    </el-dialog>
    <boxcode ref="aftersaleboxcode" v-show="false"></boxcode>

    <el-dialog
      title="创建工单"
      append-to-body
      center
      :visible.sync="isShowAdd"
      top="250px"
      width="600px"
      @close="closeAdd"
    >
      <div class="exportbtnbox">
        <div class="box1">
          <i>*</i><span style="width:65px">来源单号</span>
          <el-input
            type="textarea"
            autosize
            resize="none"
            placeholder="请输入"
            v-model="build.businessKey"
            :disabled="true"
          ></el-input>
        </div>
        <div class="box2">
          <i>*</i><span>问题类型</span>
          <div>
            <el-cascader
              v-model="build.problemTypes"
              :options="options"
              clearable
              filterable
              class="cascader"
              placeholder="请选择问题类型"
              @change="handleChange"
            />
            <el-tooltip placement="top">
              <div slot="content">
                <div>{{ descPrompt }}</div>
              </div>
              <span class="el-icon-question pointer" />
            </el-tooltip>
          </div>
        </div>
        <div class="box1 box-descript">
          <i>*</i><span style="width:65px;margin-left: 2px;">问题描述</span>
          <el-input
            type="textarea"
            :rows="3"
            placeholder="请输入实物型号、品牌、（实收）数量、商品现状描述、具体破损位置、不符合退换原因、客户姓名地址手机号、承运商、收费价格及原因"
            v-model="build.description"
          ></el-input>
        </div>
        <div class="box-img">
          <span>上传图片</span>
          <!-- action="http://dev.nagy.ruigushop.com/exception-order/image" -->
          <el-upload
            class="img-upload"
            :action="addImgUrl"
            :headers="headers"
            list-type="picture-card"
            :auto-upload="true"
            :limit="5"
            :before-upload="beforeAvatarUpload"
            :on-success="successImg"
            :file-list="fileList"
            :on-exceed="exce"
          >
            <i slot="default" class="el-icon-plus"></i>
            <div slot="file" slot-scope="{ file }">
              <img
                class="el-upload-list__item-thumbnail"
                :src="file.url"
                alt=""
              />
              <span class="el-upload-list__item-actions">
                <span
                  class="el-upload-list__item-preview"
                  @click="handlePictureCardPreview(file)"
                >
                  <i class="el-icon-zoom-in"></i>
                </span>
                <span
                  v-if="!build.disabled"
                  class="el-upload-list__item-delete"
                  @click="handleRemove(file)"
                >
                  <i class="el-icon-delete"></i>
                </span>
              </span>
            </div>
          </el-upload>
          <el-dialog :visible.sync="build.dialogVisible">
            <img width="100%" :src="build.dialogImageUrl" alt="" />
          </el-dialog>
        </div>
        <div class="img-info">
          <!-- <span @click="cloneImg">同步售后图片</span> -->
          （最多支持上传5张）
        </div>
        <!-- 上传视频 -->
        <div class="box-img">
          <span>上传视频</span>
          <!-- action="http://dev.nagy.ruigushop.com/exception-order/image" -->
          <el-upload
            class="img-upload video-upload"
            :action="addVideoUrl"
            :headers="headers"
            list-type="picture-card"
            :auto-upload="true"
            :limit="3"
            :before-upload="beforeAvatarUploadVideo"
            :on-success="successVideo"
            :file-list="videoList"
            :on-exceed="exceVideo"
          >
            <i slot="default" class="el-icon-plus"></i>
            <div slot="file" slot-scope="{ file }">
              <video
                v-bind:src="file.url"
                class="avatar video-avatar"
                controls="controls"
                style="width: 100%;"
              >
                您的浏览器不支持视频播放
              </video>
              <span class="el-upload-list__item-video">
                <span v-if="!build.disabled" @click="handleRemoveVideo(file)">
                  <i
                    class="el-icon-error"
                    style="color:#333;cursor: pointer;"
                  ></i>
                </span>
              </span>
            </div>
          </el-upload>
        </div>
        <div class="img-info">（最多支持上传3个视频）</div>

        <div class="add-margin">
          <el-button type="primary" class="button-bg-color" @click="saveAdd"
            >提 交</el-button
          >
          <el-button @click="closeAdd">取 消</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  buildWorkOrder,
  addImg,
  addVideo,
  newWorkOrderType,
  aftersaleImg
} from "@/models/exceptionModel";
import {
  getAsOrderStatus,
  getAsOrderType,
  getAftersaleList,
  getBigaftersaleList,
  getBigaftersaleDetail,
  receiptDelay,
  printBox,
  exportAftersaleList,
  getServiceNowTime,
  getNewASList, //订单查询列表
  getBoxStatus //物流状态枚举
} from "@/models/aftersaleModel";
import afterSaleTable from "@/components/bigAftersale/aftersale-table.vue";
import afterSaleDetailTable from "@/components/bigAftersale/aftersale-detail-table.vue";
import afterSaleEditDialog from "@/components/bigAftersale/aftersale-edit-dialog.vue";
import closeReasonDialog from "@/components/bigAftersale/close-reason-dialog.vue";
import orderDialog from "@/components/order/order-status-dialog.vue";
import waybillDetial from "./waybillDetial";
import boxcode from "@/components/print/boxcode";
import orderTrack from "@/components/aftersale/order-track.vue"; //物流轨迹
import Countdown from "@/utils/time";

export default {
  components: {
    afterSaleTable,
    afterSaleDetailTable,
    afterSaleEditDialog,
    closeReasonDialog,
    orderDialog,
    waybillDetial,
    boxcode,
    orderTrack
  },
  data() {
    return {
      isShowAdd: false,
      build: {
        businessKey: null,
        description: null,
        problemTypes: [],
        dialogImageUrl: [],
        dialogVisible: false,
        disabled: false
      },
      options: [],
      isVisibled: true,
      imgArr: [],
      videoArr: [], //视频文件
      addImgUrl: addImg,
      addVideoUrl: addVideo,
      headers: {
        Authorization: localStorage.getItem("token")
      },
      fileList: [],
      videoList: [], //视频文件
      descPrompt: "",

      isZhifaOrFactory:
        localStorage.getItem("shop_type") === "1" ||
        localStorage.getItem("shop_type") === "2",
      boxDetailDialog: false,
      afterSaleDetailForm: {
        start_time: "",
        end_time: "",
        as_number: "",
        order_number: "",
        ruigu_code: "",
        self_code: "",
        as_type: "",
        // as_status: "",
        //工厂|直发 支持多选
        as_status:
          localStorage.getItem("shop_type") === "1" ||
          localStorage.getItem("shop_type") === "2"
            ? []
            : "",
        delivery_number: "",
        express_type: "",
        as_status_source: "",
        user_name: "",
        courier_mobile: "",
        in_box_status: "", //提货物流状态
        out_box_status: "" //送货物流状态
      },
      aftersaleDetailTableData: [],
      aftersaleDetailType: "",
      currentPage: 1,
      pagesize: 10,
      totalCount: 0,
      showPrintType: false,
      showLabel: false,
      statusList: [],
      typeList: [],
      aftersaleTableData: [],
      loadingAftersale: true,
      selectSaleData: [],
      outEnable: true, // 售后出库btn
      closeEnable: true, // 关闭售后btn
      extendEnable: true, // 延长btn
      receiveEnable: true, // 售后收货btn
      confirmEnable: true, // 售后确认btn
      labelEnable: true, // 打印售后标签btn
      sheetEnable: false, // 打印售后发货单btn
      boxData: [],
      rowData: "", // 查看id
      showPagination: false, // 解决返回当前页currentPage为1问题
      statusActive: 1, // 当前tab
      hasConfirmOrderNum: 0, // 进入计时的单数
      showAfterSaleSeach: true, // 平台 待售后确认 和 待售后出库不显示售后状态下拉框
      logStatusOptions: {}, //物流状态
      logStatusOptions2: {}, //物流状态
      activeName: "goods_info", //默认展示商品信息
      current_row_as_number: undefined, //当前选中行售后单号
      shop_id: localStorage.getItem("shop_id"),
      shopIds: [
        // "4",
        "266",
        "381",
        "386",
        "390",
        "392",
        "395",
        "401",
        "405",
        "407",
        "413",
        "416",
        "421",
        "426"
      ] //不展示“售后出库”的店铺ID
    };
  },
  watch: {
    // 退货后面四个不能点 勾选表格
    selectSaleData(val) {
      // 选择一个售后单才能进行售后操作
      if (val.length === 1) {
        // 平台
        // 售后确认是已出分仓才能点
        // 已确认能点售后出库和两个打印
        // 直发
        // 客户已发货可以点延长和售后收货
        // 已收货可以点售后确认
        // 已确认能点售后出库和两个打印
        let labelList = JSON.stringify(
          this.statusList.filter(item => item.value == val[0].as_status)
        );
        // console.log(val, "oooooooooooo", this.statusList, labelList);
        let tpList = JSON.stringify(
          this.typeList.filter(item => item.value == val[0].as_type)
        );
        this.extendEnable = labelList.search("客户已发货") === -1; // 延长btn
        // this.receiveEnable = labelList.search('客户已发货') === -1 && labelList.search('新申请') === -1 // 售后收货btn

        // 2021/11/17 修改 售后收货 显示逻辑 不为已收货  且 as_status<21
        // console.log("lable::::", labelList);
        this.receiveEnable = !(
          labelList.search("已收货") === -1 &&
          Number(JSON.parse(labelList)[0].value) < 21
        );

        this.outEnable = !(
          tpList.search("维修") !== -1 &&
          (labelList.search("已确认") !== -1 ||
            labelList.search("维修中") !== -1)
        ); // 售后出库btn
        this.labelEnable = !(
          tpList.search("维修") !== -1 &&
          val[0].as_status >= 23 &&
          val[0].as_status !== 50
        );
        // 打印售后标签btn 工厂店铺打印售后只有维修单可以打印
        this.sheetEnable = !(tpList.search("维修") !== -1); // 打印售后发货单btn

        // 2021/11/17 修改 售后确认 修改显示逻辑 售后状态为21才显示按钮
        // 已确认 21 退货
        // 维修中 21 维修
        if (tpList.search("维修") !== -1) {
          this.confirmEnable = !(
            tpList.search("维修") !== -1 &&
            Number(JSON.parse(labelList)[0].value) == 21
          );
        }
        if (tpList.search("退货") !== -1) {
          this.confirmEnable = !(
            tpList.search("退货") !== -1 &&
            Number(JSON.parse(labelList)[0].value) == 21
          );
        }
      } else {
        this.closeEnable = true;
        this.outEnable = true;
        this.extendEnable = true;
        this.receiveEnable = true;
        this.confirmEnable = true;
        this.labelEnable = true;
        // this.sheetEnable = true
      }
    }
  },
  mounted() {
    this.getInitialData();
    // 2021-11-22 从工单管理详情页跳转过来
    if (this.$route.query.businessKey) {
      console.log(this.$route.query.businessKey);
      this.afterSaleDetailForm.as_number = this.$route.query.businessKey;
      this.searchAftersaleList();
    }

    // 2022-11-1 工厂&直发，加物流轨迹状态
    if (
      localStorage.getItem("shop_type") === "1" ||
      localStorage.getItem("shop_type") === "2"
    ) {
      this.getTrackStatus();
    }
  },
  methods: {
    // 获取物流状态枚举
    // type: 1=提,2=送
    async getTrackStatus() {
      const res = await getBoxStatus({ type: 1 });
      this.logStatusOptions = res || {};

      const res2 = await getBoxStatus({ type: 2 });
      this.logStatusOptions2 = res2 || {};
    },
    cloneImg() {
      // 同步售后图片
      aftersaleImg(this.build.businessKey)
        .then(res => {
          console.log(res);
          console.log(this.fileList);
          if (res.length) {
            res.map(item => {
              this.fileList.push({ url: item });
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 运单号(送) 修改
    async changeBoxData(row) {
      this.isShowAdd = true;
      this.build.businessKey = row.as_number;
      newWorkOrderType({
        tag: "diablo-exception-type"
      }).then(res => {
        const list = res;
        list.forEach(item => {
          item.value = item.workOrderType;
          item.label = item.workOrderTypeDesc;
          item.children = item.mapping;
          item.mapping.forEach(v => {
            v.value = v.exceptionType;
            v.label = v.exceptionTypeDesc;
          });
        });
        this.options = list;
      });
    },
    closeAdd() {
      this.isShowAdd = false;
      this.imgArr = [];
      this.videoArr = []; //视频文件
      this.fileList = [];
      this.videoList = []; //视频文件
    },
    handleChange(array) {
      if (array.length) {
        const [one, two] = array;
        const obj = this.options.find(v => v.value === one);
        const json = obj.mapping.find(v => v.value === two);
        this.descPrompt = json.desc;
      } else {
        this.descPrompt = "";
      }
    },
    // 新建的确认
    saveAdd() {
      if (
        this.build.businessKey &&
        this.build.problemTypes.length &&
        this.build.description
      ) {
        const [workOrderType, exceptionType] = this.build.problemTypes;
        let params = {
          createdByName: localStorage.getItem("username"),
          businessKey: this.build.businessKey,
          workOrderType,
          exceptionType,
          description: this.build.description,
          imgs: this.imgArr, // 图片数组
          supplierId: localStorage.getItem("supplier_id"),
          targetSystem: 1,
          sourceSystem: 5,
          videoList: this.videoArr // 视频数组
        };
        this.loading = true;
        buildWorkOrder(params)
          .then(res => {
            this.isShowAdd = false;
            this.build = {};
            this.$message({
              message: "工单创建成功。请到“锐锢在线-工单管理-我创建的”下查看。",
              type: "success"
            });
            this.piceWorkOrder();
          })
          .catch(err => {
            console.log(err);
          });
      } else {
        this.$message({
          message: "请务必填写来源单号,问题类型,问题描述",
          type: "error"
        });
      }
    },
    //上传时，判断文件的类型及大小是否符合规则
    beforeAvatarUpload(file) {
      const isJPG =
        file.type == "image/jpeg" ||
        file.type == "image/png" ||
        file.type == "image/gif";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.warning("上传头像图片只能是 JPG/PNG/GIF 格式!");
        return isJPG;
      }
      if (!isLt2M) {
        this.$message.warning("上传头像图片大小不能超过 2MB!");
        return isLt2M;
      }
      return isJPG && isLt2M;
    }, //上传视频时，判断文件的类型及大小是否符合规则
    beforeAvatarUploadVideo(file) {
      // console.log("file---", file);
      const isVideo =
        [
          "video/mp4",
          "video/ogg",
          "video/flv",
          "video/avi",
          "video/wmv",
          "video/rmvb"
        ].indexOf(file.type) > -1;
      const isLt20M = file.size / 1024 / 1024 < 20;
      if (!isVideo) {
        this.$message.warning("请上传正确的视频格式!");
        return isVideo;
      }
      if (!isLt20M) {
        this.$message.warning("视频大小不能超过20MB!");
        return isLt20M;
      }
      return isVideo && isLt20M;
    },
    successImg(res, file) {
      // console.log(res,file, 'suc');
      this.imgArr.push(file.response.data);
      this.fileList.push(file);
      // console.log(this.imgArr);
    },
    successVideo(res, file) {
      // console.log(res, file, "suc--------");
      if (res.code == 200) {
        this.videoArr.push(file.response.data.url);
        this.videoList.push(file);
      }
    },
    exce() {
      this.$message.warning("最多上传5张图片！");
    },
    exceVideo() {
      this.$message.warning("最多上传3个视频！");
    },
    handleRemove(file, fileList) {
      this.imgArr = this.imgArr.filter(item => {
        return item != file.response.data;
      });
      const filePath = file.url;
      const i = this.fileList.findIndex(x => x.url === filePath);
      this.fileList.splice(i, 1);
    },
    // 删除按钮
    handleRemoveVideo(file) {
      this.videoArr = this.videoArr.filter(item => {
        return item != file.response.data;
      });
      const filePath = file.url;
      const i = this.videoList.findIndex(x => x.url === filePath);
      this.videoList.splice(i, 1);
    },
    handlePictureCardPreview(file) {
      this.build.dialogImageUrl = file.url;
      this.build.dialogVisible = true;
    },

    // 计时
    countdownTable(arr) {
      arr.forEach((item, index) => {
        if (item.as_typeName === "维修") {
          return;
        }
        this.countdown(item.as_status_time, item.nowTime, index);
      });
    },
    // 生成计时
    countdown(time, now, index) {
      let vm = this;
      let retime = new Countdown(time, now);
      let callback = (val, timer) => {
        vm.$set(vm.aftersaleTableData[index], "showTime", val);
        vm.$set(vm.aftersaleTableData[index], "timer", timer);
      };
      retime.goAfter(callback);
      // return retime.showTime
    },
    // 清除计时
    clearTimer() {
      this.aftersaleTableData.forEach(item => {
        if (item.hasOwnProperty("timer")) {
          clearInterval(item.timer);
        }
      });
    },

    // 打印售后标签
    async printAftersale() {
      let params = {
        as_number: this.selectSaleData[0].as_number
      };
      let data = await printBox(params);
      // console.log(data, 'datesss')
      this.$refs.aftersaleboxcode.myPrint(data);
      // await data.forEach((n, i) => {
      //   print(n)
      // })
    },
    // 导出
    async exportExcel() {
      let params = {};
      params = Object.assign(params, this.afterSaleDetailForm);
      await exportAftersaleList(params);
    },
    // 打印售后发货单
    printShippingList() {
      if (this.selectSaleData.length === 1) {
        // 售后类型和售后状态都为空时显示维修和已发货的打印数据
        // 售后类型为维修，售后状态>=已出库且不为关闭
        let asId = "";
        if (this.ifSelectData()) {
          asId = this.selectSaleData[0].id;
          this.$router.push({
            name: "bigafterSaleShippingList",
            params: { as_id: asId }
          });
        }
      } else {
        this.$message.error("请选择一个售后单");
      }
    },
    // 延长商品确认
    async receiptDelay() {
      if (this.ifSelectData()) {
        let params = {
          as_number: this.selectSaleData[0].as_number
        };
        await receiptDelay(params);
        this.getAftersaleList();
      }
    },
    // 获取售后table数据
    async getSelectSaleData(val) {
      this.selectSaleData = val;
      if (val.length !== 0) {
        let params = {
          as_number: val[0].as_number,
          order_type: 1
        };
        let data = await getBigaftersaleDetail(params);
        this.aftersaleDetailTableData = data.detail;
        this.aftersaleDetailType = data.as_type;
      }
    },

    // 获取单条订单号（为了获取订单物流轨迹）2022-11-17
    getTrackNo(row) {
      this.current_row_as_number = row.as_number;
    },
    // 售后收货，售后确认，售后出库
    saleConfirm(type) {
      if (this.ifSelectData()) {
        this.$router.push({
          path: "/bigAfterSale/detail",
          query: { number: this.selectSaleData[0].as_number, type: type }
        });
      }
    },
    // 关闭售后
    async closeSale() {
      if (this.ifSelectData()) {
        this.$refs.closeReasonDialog.closeDialogVisible = true;
        this.$refs.closeReasonDialog.as_number = this.selectSaleData[0].as_number;
      }
    },
    // 是否勾选
    ifSelectData() {
      if (!this.selectSaleData || this.selectSaleData.length === 0) {
        this.$message.warning("请勾选列表");
        return false;
      } else {
        return true;
      }
    },
    // 初始化数据
    async getInitialData() {
      this.statusList = await getAsOrderStatus();
      this.typeList = await getAsOrderType();
      //工厂|直发  默认选中状态：客户已发货、已收货、维修中
      if (this.isZhifaOrFactory) {
        let as_status = [];
        this.statusList.filter(item => {
          if (
            item.label === "客户已发货" ||
            item.label === "已收货" ||
            item.label === "维修中"
          ) {
            as_status.push(item.value);
          }
        });
        this.afterSaleDetailForm.as_status = as_status;
      }

      this.getAftersaleList();

      // this.statusList = data received apply出库异常
    },
    searchAftersaleList() {
      this.currentPage = 1;
      this.getAftersaleList();
    },
    // 获取查询结果数据
    async getAftersaleList() {
      this.clearTimer();
      this.loadingAftersale = true;
      // console.log()
      let params = {
        page: this.currentPage,
        page_size: this.pagesize,
        order_type: 1
      };
      if (this.afterSaleDetailForm.hasOwnProperty("page")) {
        delete this.afterSaleDetailForm.page;
      }
      if (this.afterSaleDetailForm.hasOwnProperty("page_size")) {
        delete this.afterSaleDetailForm.page;
      }

      if (this.isZhifaOrFactory) {
        //工厂|直发 - 售后状态支持多选
        params.as_status = this.afterSaleDetailForm.as_status.slice(0).join();
        let paramsNew = {
          ...params,
          start_time: this.afterSaleDetailForm.start_time,
          end_time: this.afterSaleDetailForm.end_time,
          as_number: this.afterSaleDetailForm.as_number,
          order_number: this.afterSaleDetailForm.order_number,
          ruigu_code: this.afterSaleDetailForm.ruigu_code,
          as_type: this.afterSaleDetailForm.as_type,
          as_status: this.afterSaleDetailForm.as_status.slice(0).join(),
          delivery_number: this.afterSaleDetailForm.delivery_number,
          as_status_source: this.afterSaleDetailForm.as_status_source,
          courier_mobile: this.afterSaleDetailForm.courier_mobile,
          in_box_status: this.afterSaleDetailForm.in_box_status,
          out_box_status: this.afterSaleDetailForm.out_box_status
        };
        // 查询调新接口
        const res = await getNewASList(paramsNew);
        // console.log("工厂|直发：", res);
        this.formatterData(res);
        return;
      }
      Object.assign(params, this.afterSaleDetailForm);

      let data = await getBigaftersaleList(params);
      this.formatterData(data);
    },

    // 分页数切换
    handleSizeChange(val) {
      console.log(val, "分页数切换");
      this.pagesize = val;
      this.getAftersaleList();
    },
    // 页面跳转
    handleCurrentChange(val) {
      console.log(val, "页面跳转");
      this.currentPage = val;
      this.getAftersaleList();
    },
    // 运单号(送) 显示
    async getBoxData(row) {
      this.rowData = row;
      this.boxDetailDialog = true;
    },
    // 切换tab
    switchTab(status) {
      this.currentPage = 1;
      this.clearTimer();
      this.statusActive = status;
      this.showAfterSaleSeach = !(status === 1 || status === 2);
      console.log(this.afterSaleDetailForm, "afterSaleDetailForm");
      let params = {
        start_time: this.afterSaleDetailForm.start_time,
        end_time: this.afterSaleDetailForm.end_time,
        as_number: this.afterSaleDetailForm.as_number,
        order_number: this.afterSaleDetailForm.order_number,
        ruigu_code: this.afterSaleDetailForm.ruigu_code,
        self_code: this.afterSaleDetailForm.self_code,
        as_type: this.afterSaleDetailForm.as_type,
        as_status: "",
        delivery_number: this.afterSaleDetailForm.delivery_number,
        express_type: this.afterSaleDetailForm.express_type,
        as_status_source: this.afterSaleDetailForm.as_status_source,
        page: this.currentPage,
        page_size: this.pagesize,
        courier_mobile: this.afterSaleDetailForm.courier_mobile
      };
      console.log(params, "params");

      let stastusMap = {
        1: {
          as_status: "13"
        },
        2: {
          as_status: "22"
        },
        3: {
          as_status: ""
        }
      };
      Object.assign(params, stastusMap[status]);

      // this.afterSaleDetailForm = params
      // console.log(this.afterSaleDetailForm, params, 'params')
      getAftersaleList(params)
        .then(res => {
          this.formatterData(res);
          Object.assign(this.afterSaleDetailForm, params);
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 格式化数据
    async formatterData(res) {
      // if (!res.list) return;
      if (!res.list) {
        this.aftersaleTableData = [];
        this.totalCount = res.total;
        this.showPagination = true;
        setTimeout(() => {
          this.loadingAftersale = false;
        }, 300);
        return;
      }

      let nowTime;
      let data = await getServiceNowTime({});
      nowTime = data.data.time;
      // console.log(data, "data");
      for (let i of res.list) {
        if (i.applied_num !== i.received_num) {
          i.abnormal = "出库异常";
        }
        let matchStatusList = this.statusList.filter(
          item => item.value === i.as_status
        );
        if (matchStatusList.length !== 0) {
          i.as_statusName = matchStatusList[0].label;
        } else {
          i.as_statusName = i.as_status;
        }
        let matchTypeList = this.typeList.filter(
          item => item.value === i.as_type
        );
        if (matchTypeList.length !== 0) {
          i.as_typeName = matchTypeList[0].label;
        } else {
          i.as_typeName = i.as_type;
        }
        if (i.as_typeName === "退货") {
          i.returned_num = "";
        }
        // 2022-11-17新增
        if (this.isZhifaOrFactory) {
          i.in_box_status_msg = i.in_box_status.msg; //提货状态
          i.out_box_status_msg = i.out_box_status.msg; //送货状态
          // 1=退货，3=维修
          i.as_typeName =
            i.as_type == 1 ? "退货" : i.as_type == 3 ? "维修" : i.as_type; //售后类型
          i.as_statusName = i.as_status_str; //售后状态
        }
      }
      this.aftersaleTableData = res.list;
      this.totalCount = res.total;
      this.showPagination = true;
      setTimeout(() => {
        this.loadingAftersale = false;
      }, 300);
    },
    // 工厂店铺 售后出库 与批量录入快递
    handleCommand(val) {
      console.log(val);
    },
    // 录入物流运单
    inputTs() {
      if (this.selectSaleData.length <= 0) {
        this.$message.error("请勾选数据");
        return;
      }
      // 维修类型，“维修中、已出库、已发货、已签收、已完成”支持录入物流，其他状态不支持！
      let flag = this.selectSaleData.every(item => {
        return (
          (item.as_status == "22" ||
            item.as_status == "31" ||
            item.as_status == "32" ||
            item.as_status == "35" ||
            item.as_status == "40") &&
          item.as_type == "3"
        );
      });
      if (flag) {
        this.$router.push({
          path: "/bigAfterSale/afterSaleInputTs",
          query: {
            ids: this.selectSaleData
              .map(item => {
                return item.id;
              })
              .join(",")
          }
        });
      } else {
        this.$message.error(
          "退货：该售后类型不支持录入；维修：仅售后状态维修中、已出库、已发货、已签收、已完成支持录入！"
        );
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    // ...
    if (from.path.indexOf("/afterSale") !== -1) {
      next(vm => {
        let localData = localStorage.getItem("bigafterSale");
        if (localData) {
          let data = JSON.parse(localData);
          vm.totalCount = data.totalCount;
          vm.pagesize = data.pagesize;
          vm.currentPage = data.currentPage;
          vm.afterSaleDetailForm = data.afterSaleDetailForm;
          vm.getAftersaleList();
          vm.statusActive = parseInt(
            localStorage.getItem("bigafterSaleTabIndex")
          );
        }
      });
    } else {
      next();
    }
  },
  beforeRouteLeave(to, from, next) {
    // 离开路由前清除定时器
    this.clearTimer();
    // ...
    if (to.path.indexOf("/afterSale") !== -1) {
      let obj = {
        currentPage: this.currentPage,
        pagesize: this.pagesize,
        totalCount: this.totalCount,
        afterSaleDetailForm: this.afterSaleDetailForm
      };
      localStorage.setItem("bigafterSale", JSON.stringify(obj));
    }
    next();
  }
};
</script>
<style lang="scss">
.afterSaleDetail {
  .head-info {
    font-size: 12px;
    background: #ee9b4d;
    color: #000;
    font-weight: 600;
    padding: 3px;
    margin-bottom: 10px;
    margin-top: 5px;
    border-radius: 5px;
    padding: 5px 10px;
    span {
      color: red;
      font-size: 12px;
    }
  }
  .el-button + .el-button {
    margin-left: 0;
  }
  .boder-top {
    border-top: 1px solid #ddd;
  }
  .table-title {
    margin: 5px;
    h6 {
      font-size: 12px;
      color: #010101;
      margin: 0;
    }
  }
  .tableTitle {
    display: flex;
    justify-content: space-between;
    flex-direction: row-reverse;
    margin-bottom: 10px;
    // border-top: 1px solid #ddd;
    // padding-top: 10px;
    .el-button--small,
    .el-button--small.is-round {
      padding: 6px 8px;
    }
    p {
      line-height: 10px;
    }
  }
}
.tableStatus {
  display: flex;
  justify-content: space-between;
  div {
    display: flex;
  }
  .status {
    cursor: pointer;
    height: 30px;
    width: 80px;
    margin-right: 1px;
    margin-top: 5px;
    border-radius: 8px 8px 0px 0px;
    background-color: rgb(115, 129, 140);
    p {
      color: #fff;
      font-size: 14px;
      width: 100%;
      text-align: center;
      line-height: 4px;
    }
  }
  .status.active,
  .status:hover {
    background-color: rgb(164, 180, 193);
  }
}
p {
  line-height: 10px;
}
.btns {
  margin-top: 5px;
  .editBtn {
    background-color: #409eff;
    border-color: #409eff;
  }
}

.exportbtnbox {
  text-align: center;
  .box1 {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 10px;
    width: 90%;
    .el-textarea {
      width: 70%;
      margin-left: 10px;
    }
    i {
      color: red;
    }
  }
  .box-descript {
    align-items: flex-start;
  }
  .box2 {
    width: 88%;
    height: 50px;
    margin-left: 65px;
    position: relative;
    > i {
      position: absolute;
      top: 9px;
      left: 0;
      color: red;
    }
    > span {
      position: absolute;
      left: 13px;
      top: 9px;
    }
    .el-select {
      width: 46%;
      position: absolute;
      left: 83px;
      .el-input {
        width: 74%;
      }
    }
    .secondType {
      left: 266px;
    }
    .isVisible {
      display: none;
    }
    .cascader {
      width: 300px;
      .el-input {
        width: 100%;
      }
    }
  }
  .box-img {
    text-align: left;
    justify-content: flex-start;
    align-items: start;
    margin-left: 79px;
    > span {
      margin-right: 15px;
      width: 77px;
    }
    .img-upload {
      margin-left: 70px;
    }
    i {
      color: #8c939d;
    }
  }
  .img-info {
    text-align: left;
    margin-left: 140px;
    span {
      color: #ff6224;
      cursor: pointer;
    }
  }
  .el-button {
    padding: 10px;
    background: #fff;
    color: #606266;
    border: 1px solid #dcdfe6;
    position: relative;
    .inputfile {
      position: absolute;
      left: 0;
      top: 0;
      opacity: 0;
      height: 100%;
      width: 100%;
    }
  }
  .el-button:hover {
    border-color: #c6e2ff;
    background-color: #ecf5ff;
  }
}

.add-margin {
  margin-top: 100px;
}

.button-bg-color {
  background-color: #ff6224 !important;
  border-color: #ff6224 !important;
  color: #fff !important;
}

.add-but {
  height: 26px;
  margin-bottom: 10px;
  .el-button {
    float: right;
  }
}

.el-select-dropdown {
  min-width: 164.719px !important;
}

.el-upload--picture-card,
.el-upload-list--picture-card .el-upload-list__item {
  width: 90px;
  height: 90px;
}

.el-upload--picture-card {
  line-height: 103px;
}
.el-dialog {
  border-radius: 10px;
}

.el-dialog__header {
  background-color: #fff !important;
  text-align: left;
  padding: 20px 20px 0 !important;
  border-radius: 10px;
  position: relative;
  .el-dialog__title {
    color: #303133 !important;
    font-weight: bold;
  }
}

.el-dialog .el-dialog__header .el-dialog__headerbtn .el-dialog__close {
  color: #909399;
  position: absolute;
  right: 10px;
  top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/pages/bigAftersale/aftersale-manage.vue